module.exports = __webpack_public_path__ + "galapagos-islands.svg?09b5e6844c8fff414061f50c821f2b66";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/galapagos-islands.svg
// module id = 170
// module chunks = 10